var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 20c-.6 0-1.1-.2-1.5-.6-.9-.9-8.5-9-8.5-13.2C0 2.2 2.9 0 5.7 0c2 0 4 2 4.2 2.2h.1C10.3 2 12.3 0 14.3 0 17.1 0 20 2.1 20 6.2c0 4.2-7.6 12.3-8.5 13.2-.4.4-.9.6-1.5.6zM5.7 2C3.9 2 2 3.3 2 6.2 2 8.8 6.9 14.8 9.9 18h.1c3.1-3.2 8-9.2 8-11.8C18 3.3 16.1 2 14.3 2c-.9 0-2.2 1-2.8 1.6-.4.4-.9.7-1.5.7S8.9 4 8.5 3.6C7.9 3 6.6 2 5.7 2z"}));
}

Heart.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Heart;

Heart.default = Heart;
